import { Identity } from '../models/auth';
import { Location } from 'react-router-dom';
import { UserRole } from '@api/models/enums/UserRole';

export const hasRole = (identityRoles?: UserRole[], requiredRoles?: UserRole[], requiredAll?: boolean): boolean => {
  if (identityRoles === undefined || identityRoles.length === 0) {
    return false;
  }

  if (requiredRoles === undefined || requiredRoles.length === 0) {
    return true;
  }

  if (requiredAll) {
    return requiredRoles.every((x) => identityRoles.includes(x));
  } else {
    return requiredRoles.some((x) => identityRoles.includes(x));
  }
};

/**
 * I don't want to mark it as deprecated yet, but using a method negation role validation function is not a good idea.
 * When we add a new role, user with the role would pass. A strongly recommend using hasRole or similar function.
 */
export const hasOtherRoleThan = (identityRoles?: UserRole[], excludeRoles?: UserRole[]): boolean => {
  const requiredRoles = Object.values(UserRole).filter((x) => !(excludeRoles ?? []).includes(x));
  return hasRole(identityRoles, requiredRoles);
};

export const isQcsAdminMode = (identity: Identity): boolean => !identity.companyId && hasRole(identity.roles, [UserRole.AdminQcs]);

export const isQcsAdminCompanyMode = (identity: Identity): boolean => !!identity.companyId && hasRole(identity.roles, [UserRole.AdminQcs]);

export const isTourniquet = (identity: Identity) => hasRole(identity.roles, [UserRole.Tourniquet, UserRole.TourniquetTraining, UserRole.Training]);

export const isExternal = (identity: Identity) =>
  hasRole(identity.roles, [UserRole.ExternalManager, UserRole.ExternalWorker, UserRole.ExternalOneTime]);
export const isInternal = (identity: Identity) => !isExternal(identity);

export const isRemote = (identity: Identity) => hasRole(identity.roles, [UserRole.RemoteToken]);

export const isAnalyst = (identity: Identity) => hasRole(identity.roles, [UserRole.Analyst]);

export const getMenuNavLinkId = (id: string, identity: Identity) => {
  if (id === 'visitation' && isExternal(identity)) {
    return 'visitationExternal';
  }

  if (id === 'training' && isExternal(identity)) {
    return 'trainingExternal';
  }

  return id;
};

export const getMenuNavLinkClassName = (id: string, location: Location, identity: Identity) => {
  if (id === 'qcscompany' && location.pathname.toLowerCase().startsWith('/qcscompany')) {
    return 'active';
  }

  if (id === 'invitation' && location.pathname === '/' && isExternal(identity)) {
    return 'active';
  }

  return undefined;
};
